import { gql } from 'apollo-angular';
export const FUEL_TYPE = gql`
  query {
    fuelTypes(forCarBenefitOnly: false) {
      code
      name
    }
  }
`;
